import React from "react";

import { PopupModal } from "components/modals/ModalBox";
import useButtonLoader from "hooks/useButtonLoader";
// import { changeCouponStatus } from "services/discountManagement";
import { toastMessage } from "utils/toastMessage";

import { userBlockAndUnblockApi } from "services/user";

const BlockUnblockUser = ({
  selectedUserDetail,
  onClose,
  fetchUserManagementList,
  statusModal,
}) => {
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const status = selectedUserDetail.status === "BLOCKED" ? "Unblock" : "Block"
  // console.log("it is selected Token status:--------", selectedUserDetail);

  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const reqData = {
        id: selectedUserDetail?._id || "",
        status: selectedUserDetail.status === "BLOCKED" ? "ACTIVE" : "BLOCKED",
      };

      const {
        data: { code, status, message },
      } = await userBlockAndUnblockApi(reqData);
      if (status || code === 200) {
        fetchUserManagementList();
        onClose();
        toastMessage(message, "success", "changeUserStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };

  return (
    <>
      <PopupModal
        show={statusModal}
        handleClose={onClose}
        content={`Do You Really Want To ${status} This Customer?`}
        title="Change Customer Status"
        buttonLoader={buttonLoader}
        action={changeStatusHandler}
      />
    </>
  );
};

export default BlockUnblockUser;
